import Volume from './loaders.volume';

export { Volume as VolumeLoader };
